"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidToken = void 0;
const transform_token_html_to_object_1 = require("../transform-token-html-to-object/transform-token-html-to-object");
const isValidToken = (html, flippers) => {
    try {
        (0, transform_token_html_to_object_1.transformTokenHtmlToObject)(html, flippers);
        return true;
    }
    catch (exception) {
        return false;
    }
};
exports.isValidToken = isValidToken;
//# sourceMappingURL=is-valid-token.js.map